
import { Builder } from "@builder.io/react";
import { registerMenuGroups, commonInputs } from "./helper";
import { Testimonial1, Testimonial2, Testimonial3 } from "@/components/Testimonial";

const testimonialGroups = [
{
  name: "Testimonial Components",
  items: [
    { name: "Testimonial 1" },
    { name: "Testimonial 2" },
    { name: "Testimonial 3" }
  ]
},
];

export const registerTestimonialComponents = () => {
  registerMenuGroups(testimonialGroups);

  // Testimonial Components
  Builder.registerComponent(Testimonial1, {
    name: "Testimonial 1",
    friendlyName: "Testimonial 1",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "testimonials",
        type: "list",
        defaultValue: [
          {
            badge: [
              {
                badge: "Badge 1",
              },
              {
                badge: "Badge 2",
              },
            ],
            content: "Content 1",
            mediaType: "image",
            image: "/placeholder.svg",
            imageAltText: "Testimonial Image",
            author: "Author 1",
            company: "Company 1",
            hasButton: true,
            buttonStyle: "outline",
            buttonText: "Button Text 1",
            buttonLink: "/",
          },
          {
            badge: [
              {
                badge: "Badge 3",
              },
              {
                badge: "Badge 4",
              },
            ],
            content: "Content 2",
            mediaType: "image",
            image: "/placeholder.svg",
            imageAltText: "Testimonial Image",
            author: "Author 2",
            company: "Company 2",
            hasButton: true,
            buttonStyle: "outline",
            buttonText: "Button Text 2",
            buttonLink: "/",
          },
        ],
        subFields: [
          {
            name: "badge",
            type: "list",
            subFields: [
              ...commonInputs.contentInputs({
                includeBadge: true,
              }),
            ],
          },
          ...commonInputs.contentInputs({
            includeContent: true,
          }),
          ...commonInputs.videoImageSelection,
          ...commonInputs.testimonialInput({
            includeAuthor: true,
            includeCompany: true,
            includeButton: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Testimonial2, {
    name: "Testimonial 2",
    friendlyName: "Testimonial 2",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "testimonials",
        type: "object",
        defaultValue: {
          mainTestimonial: {
            mediaType: "image",
            image: "/placeholder.svg",
            imageAltText: "Testimonial Image",
            content: "Testimonial Content",
            author: "John Doe",
            company: "Company Name",
            hasButton: true,
            buttonStyle: "outline",
            buttonText: "Button Text",
            buttonLink: "/",
          },
          testimonials: [
            {
              image: "/placeholder.svg",
              imageAltText: "Testimonial Image",
              content: "Testimonial Content",
              author: "John Doe",
              company: "Company Name",
              link: "/",
            },
            {
              initials: "AB",
              imageAltText: "Testimonial Image",
              content: "Testimonial Content",
              author: "John Doe",
              company: "Company Name",
              link: "/",
            },
          ],
        },
        subFields: [
          {
            name: "mainTestimonial",
            type: "object",
            subFields: [
              ...commonInputs.videoImageSelection,
              ...commonInputs.testimonialInput({
                includeContent: true,
                plainTextContent: true,
                includeAuthor: true,
                includeCompany: true,
                includeButton: true,
              }),
            ],
          },
          {
            name: "testimonials",
            type: "list",
            subFields: [
              ...commonInputs.imageInput({
                name: "image",
                includeAltText: true,
              }),
              ...commonInputs.testimonialInput({
                includeContent: true,
                plainTextContent: true,
                includeAuthor: true,
                includeInitials: true,
                includeCompany: true,
                includeLink: true,
              }),
            ],
          },
        ],
      },
    ],
  })

  Builder.registerComponent(Testimonial3, {
    name: "Testimonial 3",
    friendlyName: "Testimonial 3",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
      }),
      {
        name: "testimonials",
        type: "list",
        defaultValue: [
          {
            image: "/placeholder.svg",
            imageAltText: "Testimonial Image",
            content: "Testimonial Content",
            author: "John Doe",
            company: "Company Name",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Testimonial Image",
            content: "Testimonial Content",
            author: "John Doe",
            company: "Company Name",
          },
        ], 
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.testimonialInput({
            includeContent: true,
            includeAuthor: true,
            includeInitials: true,
            includeCompany: true,
            includeLink: true,
          }),
        ],
      },
    ],
  })
}